const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-joblog/shared/lib/approval-overview-sidebar-button-registry");